import React from 'react';
import Slider from 'react-slick';

import HeroImage from '../../components/HeroImage/HeroImage';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../Carousel/Carousel.css';

function Carousel(props) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
        },
      },
    ],
  };
  return (
    <Slider {...settings} className="banner">
      {props.content.map(item => (
        <HeroImage
          withoutZoom={props.withoutZoom}
          disableLink={props.disableLink}
          inCarousel
          src={item.bannerImage.url}
          content={item.textImage}
          url={item.linkCampaignUrl}
        />
      ))}
    </Slider>
  );
}

export default Carousel;
